import React from 'react'

const Interests = () => {
    return (
        <div>
            <h1>Interests Page : Coming Soon....</h1>
        </div>
    )
}

export default Interests;
